export default __webpack_public_path__ + "static/char-s-57-en-2b3ee776843aa2a021c0f6fdf5071455.png";